// Orders Routing

import OrdersPage from "components/pages/orders/OrdersPage";
import ServiceRequestPage from "components/pages/orders/ServiceRequestPage";
import BackorderedOrdersPage from "components/pages/orders/BackorderedOrdersPage";

const ORDERS_ROUTES = {
	path: "orders",
	children: [
		{ path: "", element: <OrdersPage /> },
		{ path: "service-requests", element: <ServiceRequestPage /> },
		{ path: "backordered", element: <BackorderedOrdersPage /> },
	],
};

export default ORDERS_ROUTES;
